import { useTranslation } from "react-i18next";

import { Box, Typography } from "@mui/material";

import { formatEuro } from "../../../../../../../../../../format/formatNumber";

interface Props {
  amount: number | null;
}

export function ReadOnlyAmount({ amount }: Props) {
  const { i18n } = useTranslation();

  return (
    <Box
      sx={{
        borderRadius: 1,
        px: 1.75,
        minHeight: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
        {amount === null ? "–" : formatEuro(amount, i18n.language)}
      </Typography>
    </Box>
  );
}
